import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Transaction, TransactionStatus, TrackingStatus } from 'src/app/models/transaction';
import { AppConstants } from "src/app/app_setting/app-constants";

@Component({
  selector: 'app-transaction-detail',
  templateUrl: './transaction-detail.component.html',
  styleUrls: ['./transaction-detail.component.css']
})
export class TransactionDetailComponent implements OnInit {

  @Input() transaction: Transaction = new Transaction();
  @Output() backToList: EventEmitter<any> = new EventEmitter<any>();

  status: string;
  startPrice = 0;
  totalDiscount = 0;
  tax = 0;
  priceAfterTax = 0;
  sealFee = 0;
  finalPrice = 0;
  priceBeforeTax = 0;

  constructor(public datepipe: DatePipe) { }

  public get getTransactionStatus() {
    return TransactionStatus;
  }

  public get getTrackingStatus() {
    return TrackingStatus;
  }

  ngOnInit() {
    const data = this.transaction as any;

    this.startPrice = data.total_gross_value;
    this.tax = data.total_tax;
    this.totalDiscount = data.total_disc;
    this.priceAfterTax = data.total_gross_value - data.total_disc + data.total_tax;
    this.sealFee = data.total_materai;
    this.priceBeforeTax = data.total_gross_value - data.total_disc;
    this.finalPrice = data.total_net_value + data.total_tax + data.total_materai;// data.total;
    if (this.transaction.show_price_detail) {
      this.transaction.total = this.finalPrice;
    }

    switch (this.transaction.status) {
      case TransactionStatus.Created:
        this.status = "Pesanan Dibuat";
        break;
      case TransactionStatus.InProcess:
        this.status = "Pesanan Diproses";
        break;
      case TransactionStatus.Sent:
        this.status = "Pesanan Dikirim";
        break;
      case TransactionStatus.Delivered:
        this.status = "Pesanan Diterima";
        break;
      default:
        this.status = "Pesanan Dibuat";
        break;
    }
  }

  back() {
    this.backToList.emit();
  }

  changeSource(event) {
    event.target.src = AppConstants.ProductImageDefault;
  }

  resolveProductImage(imageUrl: string): string {
    if (imageUrl === null || imageUrl === "" || imageUrl === undefined) {
      return AppConstants.ProductImageDefault;
    }

    return imageUrl;
  }
}
